module.exports = __webpack_public_path__ + "img/dollar-sign.18c4dec0.svg";